<script setup lang="ts">
const telegramUrl = 'https://t.me/LilyaPokatayeva_bot?start=dl-1778234890875'
</script>

<template>
  <div class="partner-success">
    <div class="partner-success__card">
      <img
        class="partner-success__icon"
        src="https://storage.yandexcloud.net/terpay/success-icon.png"
        alt=""
        width="64"
        height="64"
      />
      <h1 class="partner-success__title">Спасибо. Оплата прошла успешно!</h1>
      <p class="partner-success__text">
        Информация о спринте и обещанные бонусы за регистрацию ждут вас в Telegram. Переходите по
        кнопке ниже&#128071;&#127996;
      </p>
      <a
        class="partner-success__button"
        :href="telegramUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        ПЕРЕЙТИ В ТЕЛЕГРАМ
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.partner-success {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;

  &__card {
    background: #fff;
    border-radius: 16px;
    padding: 40px 32px;
    max-width: 480px;
    width: 100%;
    text-align: center;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  &__icon {
    width: 64px;
    height: 64px;
    object-fit: contain;
  }

  &__title {
    font-size: 22px;
    font-weight: 700;
    line-height: 1.3;
    color: var(--color-black-99, #1a1a1a);
    margin: 0;
  }

  &__text {
    font-size: 16px;
    line-height: 1.5;
    color: var(--color-gray-60, #666);
    margin: 0;
  }

  &__button {
    display: block;
    width: 100%;
    padding: 14px 24px;
    background-color: var(--color-accent, #29b6f6);
    color: var(--color-black-99, #1a1a1a);
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
    border-radius: var(--rounded-lg, 12px);
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.75;
    }
  }
}
</style>
